module.exports = __webpack_public_path__ + "img/whats-new-mobile_en.89a7a5c.jpg";